import { t } from '@/i18n';
import {
  Box,
  Button,
  ButtonProps,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  ModalProps,
} from '@chakra-ui/react';
import { ReactNode } from 'react';

export interface ConfirmationModalProps extends Pick<ModalProps, 'isOpen' | 'onClose'> {
  onConfirm(): void;
  title?: ReactNode;
  description?: ReactNode;
  confirmLabel?: ReactNode;
  cancelLabel?: ReactNode;
  isLoading?: boolean;
  withoutCloseButton?: boolean;
  confirmButtonProps?: Omit<ButtonProps, 'onClick' | 'isLoading'>;
  closeOnOverlayClick?: boolean; // Adicionada para suportar a propriedade
}

export const ConfirmationModal = ({
  isOpen,
  onClose,
  onConfirm,
  title = t('components.confirmation_modal.confirmation_modal_confirm_label'),
  description,
  confirmLabel = t('components.confirmation_modal.confirmation_modal_confirm_label'),
  cancelLabel = t('components.confirmation_modal.confirmation_modal_cancel_label'),
  isLoading = false,
  withoutCloseButton = false,
  confirmButtonProps,
  closeOnOverlayClick = true, // Valor padrão para compatibilidade
}: ConfirmationModalProps) => {
  return (
    <Modal isOpen={isOpen} onClose={onClose} closeOnOverlayClick={closeOnOverlayClick}>
      <ModalOverlay />
      <ModalContent>
        <ModalHeader>{title}</ModalHeader>
        {withoutCloseButton ? null : <ModalCloseButton />}
        <ModalBody>
          <Box fontWeight='medium' mb='1rem'>
            {description}
          </Box>
        </ModalBody>

        <ModalFooter gap='kilo'>
          <Button variant='outlined' color='gray.600' onClick={onClose} isDisabled={isLoading}>
            {cancelLabel}
          </Button>
          <Button onClick={onConfirm} isLoading={isLoading} {...confirmButtonProps}>
            {confirmLabel}
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
};
